import React from 'react';
import { useStateValue } from './StateProvider';
import './Product.css';

function Product({ id, bestSeller, title, imgUrl, mprice, oprice, ratings, qty }) {

    const [{ basket }, dispatch] = useStateValue();

    console.log("in basket", basket);




    const addToBasket = (e) => {
        //adds item to datalayer
        e.preventDefault();
        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                id: id,
                bestSeller: bestSeller,
                title: title,
                imgUrl: imgUrl,
                mprice: mprice,
                oprice: oprice,
                ratings: ratings,
                qty: qty

            }
        });







    };











    return (
        <div className="product col-md-3 ">
            <div className="box p-2 mt-2">
                <div className="product__info ">
                    {(bestSeller === 1) ? <span className="product__bestSeller"> Best Seller</span> : ""
                    }
                    <img src={imgUrl} className="img-fluid" alt="product img" />
                    <p>{title}</p>

                    <div className="product__rating">


                        {Array(ratings).fill(1).map(e => '⭐')}


                    You Save:   {mprice - oprice} ({parseInt(((mprice - oprice) / mprice) * 100)}%)
                </div>

                    <span className="product__oprice">
                        ₹{oprice}
                    </span>

                    <span
                        className="product__mprice">
                        ₹{mprice}
                    </span>
                    <div className="d-flex align-items-center">
                        <button className="product__addToBasket btn-sm-block " onClick={addToBasket} >Add To Basket
                    </button>
                    </div>




                </div>

            </div>
        </div>
    )
}

export default Product
